import styled from 'styled-components';

export const Wrapper = styled.div`
  .listing-table {
    box-shadow: 0px 4px 60px rgba(0, 0, 0, 0.05);
    background: ${(props) => props.theme.colors.white};
    border-radius: 12px;
  }

  .filter-card,
  .composer-card {
    box-shadow: 0px 4px 60px rgba(0, 0, 0, 0.05);
    border: none;
    border-radius: 12px;
    background: ${(props) => props.theme.colors.white};
  }

  .filter-card {
    position: sticky;
    top: 20px;
    max-height: calc(100vh - 120px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .active-filters {
    padding: 0.75rem;
    background: ${(props) => props.theme.colors.gray7 || '#f8f9fa'};
    border-radius: 8px;
  }

  .no-filters-message {
    padding: 0.75rem;
    background: ${(props) => props.theme.colors.gray7 || '#f8f9fa'};
    border-radius: 8px;
  }

  .test-send-card,
  .template-card {
    background: ${(props) => props.theme.colors.gray7 || '#f8f9fa'};
    border: 1px dashed ${(props) => props.theme.colors.gray6 || '#dee2e6'};
  }

  .template-card {
    .template-card {
      background: ${(props) => props.theme.colors.white};
      border: 1px solid ${(props) => props.theme.colors.gray6 || '#e9ecef'};
    }

    .templates-list {
      max-height: 300px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  }

  .filter-section {
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray6 || '#e9ecef'};

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .filter-label {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${(props) => props.theme.colors.gray3 || '#495057'};
    margin-bottom: 0.5rem;
    display: block;
  }

  .form-control,
  .form-select {
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.gray6 || '#dee2e6'};
    padding: 0.6rem 1rem;
    font-size: 0.9rem;

    &:focus {
      border-color: ${(props) => props.theme.colors.primary};
      box-shadow: 0 0 0 0.2rem rgba(242, 180, 32, 0.25);
    }

    &:disabled {
      background-color: ${(props) => props.theme.colors.gray7 || '#f8f9fa'};
      cursor: not-allowed;
    }
  }

  .form-check-input {
    cursor: pointer;

    &:checked {
      background-color: ${(props) => props.theme.colors.primary};
      border-color: ${(props) => props.theme.colors.primary};
    }

    &:focus {
      border-color: ${(props) => props.theme.colors.primary};
      box-shadow: 0 0 0 0.2rem rgba(242, 180, 32, 0.25);
    }
  }

  .form-check-label {
    cursor: pointer;
    user-select: none;
  }

  .duration-input {
    display: grid;
    grid-template-columns: 2fr 3fr 2fr;
    gap: 0.5rem;
    align-items: center;
  }

  .number-range-input {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 0.5rem;
    align-items: center;
  }

  .ck-editor__editable {
    min-height: 400px;
  }

  @media (max-width: 991px) {
    .filter-card {
      position: relative;
      top: 0;
      max-height: none;
    }
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 800px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);

  .modal-header {
    padding: 1.5rem;
    border-bottom: 1px solid #dee2e6;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h5 {
      margin: 0;
      font-weight: 600;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 1.5rem;
      cursor: pointer;
      color: #6c757d;
      padding: 0;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: all 0.2s;

      &:hover {
        background: #f8f9fa;
        color: #000;
      }
    }
  }

  .modal-body {
    padding: 1.5rem;
    overflow-y: auto;
    flex: 1;
  }

  .modal-footer {
    padding: 1rem 1.5rem;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
  }
`;
